import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {LocalStorage} from "./storage.service";
import {Customer} from "../models/customer.model";

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  API = `${environment.apiUrl}/tenant`;

  /** Current selected tenant */
  @LocalStorage('selected_customer', Customer)
  customer: Customer;

  /** List of all use tenants */
  @LocalStorage('customers', Customer)
  private _allCustomers: Customer[];

  /** Gets tenant list */
  get allCustomers(): Customer[] {
    return this._allCustomers;
  }

  /** Sets selected tenant and tenant list */
  set allCustomers(customers: Customer[]) {
    this.customer = customers[0];
    this._allCustomers = customers;
  }

  constructor() { }
}
